// Polyfill para Buffer (necesario para sha1 y otras librerías de Node.js)
import { Buffer } from 'buffer'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import 'bootstrap-icons/font/bootstrap-icons.css'

window.Buffer = Buffer

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}
  >
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>
)
